import * as React from 'react'

import * as styles from './UserVerificationResend.module.scss'
import { generateTokenService } from 'services/token'
import { CONFIRMATION_TYPES } from 'components/forms/confirmation-modal/constants'
import { setTokenData } from 'util/countdown-store'

export const UserVerificationResend = ({
  email = 'a@gmail.com',
  firstName,
  lastName,
  tokenSource = 'RECEIPT_UPLOAD',
  permalink = 'a-b',
  goToVerification,
  goBackToSignUp,
  verificationCodeExpiration = 900, // Test with 30 seconds
  manualResendCooldown = 180, // 3 minutes
  formClassName = styles.formWrapper,
}) => {
  const [loading, setLoading] = React.useState(false)
  const onSendToken = async ({
    firstName,
    lastName,
    email,
    permalink,
    tokenSource,
    tokenSourceId,
  }) => {
    return await generateTokenService({
      firstName,
      lastName,
      email,
      permalink,
      tokenSource: tokenSource || '',
      tokenSourceId: tokenSourceId || '',
    })
  }

  const handleResend = async () => {
    setLoading(true)
    const confirmationData = {
      email,
      firstName,
      lastName,
      tokenSource,
      permalink,
      type: CONFIRMATION_TYPES.EMAIL,
    }
    await onSendToken(confirmationData).finally(async () => {
      setLoading(false)
      goToVerification()
      const now = Date.now()
      await setTokenData(email, {
        tokenExpiresAt: now + verificationCodeExpiration * 1000,
        canSendAnNewTokenAt: now + manualResendCooldown * 1000,
      })
    })
  }

  return (
    <div className={`${formClassName}`}>
      <div className={styles.wrapper}>
        <span className={styles.header}>Resend Your Verification Email</span>
        <button
          disabled={loading}
          onClick={handleResend}
          className={`${styles.resendLink} btn`}
          type="submit"
        >
          Get a New Code
        </button>
        <span className={styles.content}>
          <span onClick={goBackToSignUp}>
            If you’d like to edit your email address, you’ll need to go back to
            Sign Up in order to complete the verification process.
          </span>
        </span>
      </div>
    </div>
  )
}
